/*=========================================================================================
  File Name: gettes.js
  Description: Order Manager Getters
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/
import moment from 'moment'
export default {
    minDuration : (state, getters, rootState) => {
      if(rootState.cart.estimatedTime <= state.currentWaitingTime) {
        return state.currentWaitingTime;
      }
      else if ((rootState.cart.estimatedTime > state.currentWaitingTime) 
                && (rootState.cart.estimatedTime <= state.maxWaitingTime)) {
        return rootState.cart.estimatedTime;            
      }
      else {
        return state.maxWaitingTime;
      }
    }
}